"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _colors = require("HubStyleTokens/colors");

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UITile = _interopRequireDefault(require("UIComponents/tile/UITile"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _PriceDisplay = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/pricing/PriceDisplay"));

var _CurrencySelectors = require("pricing-pages-unified-ui/selectors/CurrencySelectors");

var _PricingSelectors = require("../../selectors/PricingSelectors");

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  color: ", ";\n  text-align: center;\n  font-size: 17px;\n  padding-right: 40px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  color: ", ";\n  font-size: 12px;\n  line-height: initial;\n  display: inline-block;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  transform: rotate(90deg); /* Standard syntax */\n  top: 18px;\n  right: 18px;\n  position: absolute;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: absolute;\n  right: -81px;\n  transform: rotate(-90deg); /* Standard syntax */\n  border-bottom: 0;\n  margin-top: 110px;\n  padding: 10px;\n  line-height: 20px;\n  height: 60px;\n  width: 220px;\n  cursor: pointer;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var SideUITile = (0, _styledComponents.default)(_UITile.default).withConfig({
  displayName: "Wp006ShowEnterpriseSideTab__SideUITile",
  componentId: "sxlj0k-0"
})(_templateObject());
var TopRightButton = (0, _styledComponents.default)(_UIButton.default).withConfig({
  displayName: "Wp006ShowEnterpriseSideTab__TopRightButton",
  componentId: "sxlj0k-1"
})(_templateObject2());

var PriceCSS = _styledComponents.default.div.withConfig({
  displayName: "Wp006ShowEnterpriseSideTab__PriceCSS",
  componentId: "sxlj0k-2"
})(_templateObject3(), _colors.SLINKY);

var SideTabDiv = _styledComponents.default.div.withConfig({
  displayName: "Wp006ShowEnterpriseSideTab__SideTabDiv",
  componentId: "sxlj0k-3"
})(_templateObject4(), _colors.CALYPSO_DARK);

var Wp006ShowEnterpriseSideTab = function Wp006ShowEnterpriseSideTab(_ref) {
  var setEnterpriseVisible = _ref.setEnterpriseVisible,
      pricingInfo = _ref.pricingInfo,
      activeCurrencyCode = _ref.activeCurrencyCode,
      merchandiseId = _ref.merchandiseId;
  var monthlyFullPrice = pricingInfo.monthly.fullPrice;
  return _react.default.createElement(SideUITile, {
    compact: true,
    align: "center",
    onClick: setEnterpriseVisible
  }, _react.default.createElement(SideTabDiv, null, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.wp006Simplify.showEnterprise"
  })), _react.default.createElement(TopRightButton, {
    use: "unstyled",
    onClick: setEnterpriseVisible
  }, _react.default.createElement(_UIIcon.default, {
    name: "first",
    size: 20,
    style: {
      color: _colors.FLINT
    },
    onClick: setEnterpriseVisible
  })), _react.default.createElement("div", {
    style: {
      textAlign: 'center',
      paddingRight: '40px'
    }
  }, _react.default.createElement(_FormattedJSXMessage.default, {
    message: "pricingPage.pricingPerMonthWp006_jsx",
    options: {
      currencyCode: activeCurrencyCode,
      price: monthlyFullPrice,
      merchandiseId: merchandiseId
    },
    elements: {
      PriceDisplay: _PriceDisplay.default,
      MicroCopy: _Small.default,
      PriceContainer: PriceCSS
    }
  })));
};

var mapStateToProps = function mapStateToProps(state, _ref2) {
  var merchandiseId = _ref2.merchandiseId;
  return {
    activeCurrencyCode: (0, _CurrencySelectors.activeCurrencySelector)(state),
    pricingInfo: (0, _PricingSelectors.getCalculatePriceAndItemConfigSelector)(state)({
      merchandiseId: merchandiseId
    })
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(Wp006ShowEnterpriseSideTab);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/product-pages/Wp006ShowEnterpriseSideTab.js
// module id = 841
// module chunks = 5 6